export const FULL_WIDTH_MARGINS = 48;
export const MAX_SPACING = 300;
